export const SET_RESOURCES = 'setResources';
export const SET_RESOURCES_DICT = 'setResourcesDict';
export const SET_RESOURCE = 'setResource';
export const SET_ERROR = 'setResourcesError';

export const SET_SKELETONS_TYPES = 'setSkeletonsTypes';
export const SET_ANIMATIONS_TYPES = 'setAnimationsTypes';
export const SET_POSES_TYPES = 'setPosesTypes';
export const SET_ANIMATIONS = 'setAnimations';

export const SET_RESOURCE_TYPE = 'setResourceType';
export const REMOVE_RESOURCE_TYPE = 'removeResourceType';
